<template>
  <order-list v-if="displayOrders"
              :account="selectedAccount"
              :username="username"
              @apierror="setApiError"
              @apierrortext="setApiErrorText"
              @close="closeOrderList">
  </order-list>
  <product-list v-if="displayProducts"
                :dairy-id="selectedAccount.dairyId"
                :dairy-name="selectedAccount.dairyName"
                :customer-id="selectedAccount.customerId"
                :customer-name="selectedAccount.customerName"
                :price-deck="selectedAccount.priceDeck"
                @apierror="setApiError"
                @apierrortext="setApiErrorText"
                @close="closeProductList">
  </product-list>
  <email-dairy v-if="contactDairy"
               :account="selectedAccount"
               :username="username"
               @apierror="setApiError"
               @apierrortext="setApiErrorText"
               @close="closeEmailDairy">
  </email-dairy>
  <div class="centered">
    <div>
      <announcement-banner v-if="showAccounts" :dairyId="accounts[0].dairyId"/>
      <div v-show="showAccounts" class="table-container" style="width:60%;">
        <div style="width:100%;background:lightgray;border-bottom:1px solid black;">
          <div style="height:55px;">
            <div class="role-text" style="float:left;padding-top:1%;">
              <span>My accounts</span>
            </div>
            <div style="float:right;text-align:right;width:20%;padding-top:1%;">
              <a href="./assets/users/help/RCO User Guide.pdf" target="_blank">
                <label class="action-icon-style">
                  <font-awesome-icon icon="file-pdf" size="lg"/>
                  <span style="display: block;">guide</span>
                </label>
              </a>
            </div>
          </div>
        </div>
        <table>
          <tbody>
          <tr v-if="!accounts.length">
            <td>You currently have no assigned accounts.</td>
          </tr>
          <tr v-else v-for="account in accounts" :key="account.deliveryType">
            <td>
              <div style="text-align:left;font-weight:bold;line-height:0.75;">
                <div style="float:left;">
                  <div>
                    <sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
                  </div>
                </div>
              </div>
              <div class="product-banner">
                <div>
                  <div style="float:left;">
                    {{ account.deliveryType }} | deck: {{ account.priceDeck }}
                  </div>
                  <div style="float:right;padding-right:1%;">
                    <sup>[{{ account.dairyId }}]</sup>&nbsp;{{ account.dairyName }}
                  </div>
                </div>
              </div>
            </td>
            <td colspan="2" style="display:flex;justify-content:space-evenly;">
              <label class="action-icon-style" v-on:click="email(account)">
                <font-awesome-icon icon="envelope" size="xl"/>
                <span style="display: block;">contact</span>
              </label>
              <label class="action-icon-style" v-on:click="openProductList(account)">
                <font-awesome-icon icon="cow" size="xl"/>
                <span style="display: block;">products</span>
              </label>
              <label class="action-icon-style" v-on:click="openOrderList(account)">
                <font-awesome-icon icon="basket-shopping" size="xl"/>
                <span style="display: block;">orders</span>
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from '@/components/ordering/List'
import ProductList from '@/components/ordering/products/List'
import EmailDairy from '@/components/user/messaging/EmailDairy'
import AnnouncementBanner from '@/components/user/AnnouncementBanner.vue';

export default {
  name: 'UserComponent',
  props: ['username'],
  emits: ['apierror', 'apierrortext'],
  data: function () {
    return {
      showAccounts: false,
      selectedAccount: {},
      accounts: [],
      displayProducts: false,
      displayOrders: false,
      contactDairy: false,
    }
  },
  components: {
    OrderList,
    ProductList,
    EmailDairy,
    AnnouncementBanner
  },
  methods: {
    openProductList: function (account) {
      this.displayProducts = true
      this.selectedAccount = account
    },
    closeProductList: function () {
      this.displayProducts = false
    },
    openOrderList: function (account) {
      this.selectedAccount = account
      this.displayOrders = true
    },
    closeOrderList: function () {
      this.orders = []
      this.selectedOrder = {}
      this.displayOrders = false
    },
    email: function (account) {
      this.selectedAccount = account
      this.contactDairy = true
    },
    closeEmailDairy: function () {
      this.contactDairy = false
    },
    setApiError: function (apiError) {
      this.$emit('apierror', apiError)
    },
    setApiErrorText: function (apiErrorText) {
      this.$emit('apierrortext', apiErrorText)
    },
  },
  created() {
    this.showAccounts = false

    this.axios
        .get('assignment/list')
        .then(response => {
          this.accounts = response.data.sort((a, b) => (a.customerName > b.customerName) ? 1 : -1)
        })
        .catch(error => {
          this.setApiError(true)
          this.setApiErrorText(error.response.statusText)
        })
        .finally(() => {
          this.showAccounts = true
        })
  },
}
</script>

<style scoped>
.action-icon-style {
  color: black;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
